import React from 'react';
import GenericPullAndPushToolView from '../GenericPullAndPushToolView';
import FortifyConfigListing from './FortifyConfigListing';
import FortifyCredentialsForm from './FortifyCredentialsForm';

const FortifyPullAndPushView = (props) => (
    <GenericPullAndPushToolView 
        {...props}
        PullCredentialForm={FortifyCredentialsForm}
        PullConfigListingView={FortifyConfigListing}
     />
);

export default FortifyPullAndPushView;
